import { Grid } from '@mui/material';
import { InfoWrapper, RHFNumberTextField } from 'components';
import { useInspectionPath } from 'hooks';
import { INFO } from 'pages/Inspections/config/info';
import { useInspectionSelector } from 'stores';

const Accordion2HydraulicDataL3 = () => {
  // e-2026-06-t21 — stesso pattern di L0/L1, vedi Accordion1GeneralInfoL3.jsx.
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();
  const readOnly = inspectionDisabled || isViewingInspection;

  return (
    <Grid container spacing={2} mt={2}>
      <Grid item xs={4}>
        <RHFNumberTextField
          name="portataQP3"
          // Issue #1021, riapertura 2026-09-25, punto 42 — pedice mancante
          // su QP3/QP2/QP1/VP3/VP2/VP1, stesso pattern già in uso altrove in
          // questa sezione (es. francoIdraulicoFP2 in
          // Accordion3OvertoppingL3.jsx).
          label={
            <>
              {'Portata Q'}
              <sub style={{ fontSize: 12 }}>P3</sub>
              {' [m³/s]'}
            </>
          }
          decimalScale={2}
          defaultValue=""
          withValueLimit={({ value }) => value < 100000}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={4}>
        <RHFNumberTextField
          name="portataQP2"
          label={
            <>
              {'Portata Q'}
              <sub style={{ fontSize: 12 }}>P2</sub>
              {' [m³/s]'}
            </>
          }
          decimalScale={2}
          defaultValue=""
          withValueLimit={({ value }) => value < 100000}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={4}>
        <RHFNumberTextField
          name="portataQP1"
          label={
            <>
              {'Portata Q'}
              <sub style={{ fontSize: 12 }}>P1</sub>
              {' [m³/s]'}
            </>
          }
          decimalScale={2}
          defaultValue=""
          // Issue #1021, punto 19 — "Numerico (f7.2)" (dati-piattaforma-campi.md,
          // ID580/581/582): 7 cifre significative totali, 2 decimali → 5 cifre
          // intere, campo non firmato (nessun prefisso "-" nel formato).
          withValueLimit={({ value }) => value < 100000}
          disabled={readOnly}
        />
      </Grid>

      <Grid item xs={4}>
        <RHFNumberTextField
          name="velocitaAMonteVP3"
          label={
            <>
              {'Velocità a monte V'}
              <sub style={{ fontSize: 12 }}>P3</sub>
              {' [m³/s]'}
            </>
          }
          decimalScale={2}
          defaultValue=""
          withValueLimit={({ value }) => value < 1000}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={4}>
        <RHFNumberTextField
          name="velocitaAMonteVP2"
          label={
            <>
              {'Velocità a monte V'}
              <sub style={{ fontSize: 12 }}>P2</sub>
              {' [m³/s]'}
            </>
          }
          decimalScale={2}
          defaultValue=""
          withValueLimit={({ value }) => value < 1000}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={4}>
        <RHFNumberTextField
          name="velocitaAMonteVP1"
          label={
            <>
              {'Velocità a monte V'}
              <sub style={{ fontSize: 12 }}>P1</sub>
              {' [m³/s]'}
            </>
          }
          decimalScale={2}
          defaultValue=""
          // Issue #1021, punto 19 — "Numerico (f5.2)" (ID583/584/585): 5 cifre
          // significative totali, 2 decimali → 3 cifre intere, non firmato.
          withValueLimit={({ value }) => value < 1000}
          disabled={readOnly}
        />
      </Grid>

      <InfoWrapper
        size={4}
        infoMessage={INFO.quotaPeloLiberoP3RischioIdraulico.infoMessage}
        compassMessage={INFO.quotaPeloLiberoP3RischioIdraulico.compassMessage}
      >
        <RHFNumberTextField
          name="quotaPeloLiberoP3"
          label={'Quota del pelo libero (scenario P3) [m]'}
          decimalScale={2}
          defaultValue=""
          withValueLimit={({ value }) => value < 10000 && value > -10000}
          disabled={readOnly}
        />
      </InfoWrapper>

      <InfoWrapper
        size={4}
        infoMessage={INFO.quotaPeloLiberoP2RischioIdraulico.infoMessage}
        compassMessage={INFO.quotaPeloLiberoP2RischioIdraulico.compassMessage}
      >
        <RHFNumberTextField
          name="quotaPeloLiberoP2"
          label={'Quota del pelo libero (scenario P2) [m]*'}
          decimalScale={2}
          defaultValue=""
          withValueLimit={({ value }) => value < 10000 && value > -10000}
          disabled={readOnly}
        />
      </InfoWrapper>

      {/* Issue #1021, riapertura 2026-09-04, punto 22 — P1 non wrappato in
          InfoWrapper (nessun testo info esiste per questo campo) restava
          5px più in alto di P2/P3 sulla stessa riga (il wrapper aggiunge un
          <div style={{marginTop:5}}> attorno al children, badge "info" a
          parte, che è position:absolute e non conta ai fini del layout).
          InfoWrapper senza messaggi non renderizza il badge (hasInfo=false)
          ma applica lo stesso div di spaziatura, allineando la riga senza
          inventare un testo informativo che non esiste. */}
      <InfoWrapper size={4}>
        <RHFNumberTextField
          name="quotaPeloLiberoP1"
          label={'Quota del pelo libero (scenario P1) [m]'}
          decimalScale={2}
          defaultValue=""
          // Issue #1021, punto 19 — "Numerico (-f6.2)" (ID139/138/587): stesso
          // formato di quotaMinimaIntradosso (Accordion3OvertoppingL3.jsx),
          // verificato contro dati-piattaforma-campi.md ID134: range
          // documentato [-9999,99 ; +9999,99].
          withValueLimit={({ value }) => value < 10000 && value > -10000}
          disabled={readOnly}
        />
      </InfoWrapper>

      <Grid item xs={4}>
        <RHFNumberTextField
          name="quotaMinimaFondoAlveo"
          label={'Quota minima fondo alveo [m slm]'}
          decimalScale={2}
          defaultValue=""
          // Issue #1021, riapertura 2026-09-04, punto 19 — campo senza
          // limite (screenshot cliente: valori a decine di cifre). ID593 non
          // ha una colonna CARATTERI documentata (assente sia da
          // dati-piattaforma-campi.md, che copre solo il foglio "Dati" e non
          // "L3 idraulico", sia da l3-idraulica-tab.md) — stesso limite delle
          // quote sorelle di questa stessa sezione (quotaPeloLibero*), non
          // confermato puntualmente dal cliente per questo campo specifico.
          withValueLimit={({ value }) => value < 10000 && value > -10000}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={4}>
        <RHFNumberTextField
          name="pendenzaMedia"
          label={'Pendenza media [-]'}
          decimalScale={7}
          defaultValue=""
          // Issue #1021, riapertura 2026-09-04, punto 19 — formato confermato
          // dal cliente: "Numerico (-f8.7)" (ID608), 8 cifre significative
          // totali, 7 decimali → 1 cifra intera, campo firmato (prefisso
          // "-"). Range [-9,9999999 ; 9,9999999].
          withValueLimit={({ value }) => value > -10 && value < 10}
          disabled={readOnly}
        />
      </Grid>
    </Grid>
  );
};

export { Accordion2HydraulicDataL3 };
